export default {"src":"/_next/static/media/logo.744d262c.svg","height":32,"width":46,"blurWidth":0,"blurHeight":0};